module.exports = __webpack_public_path__ + "img/bier.bfd1920e.jpg";